class CartService {
	#addSkuListener;

	constructor() {
		this.#addSkuListener = [];
	}

	addListenerAddSku(listener) {
		this.#addSkuListener.push(listener);
	}

	add(skuId) {
		return $.ajax({
			url: window.elkitorg_config.cart_add_url,
			method: 'post',
			data: {sku_id: skuId},
			dataType: 'json'
		}).then(resp => {
			this.#addSkuListener.forEach(listener => listener(skuId, resp));
			$(document).trigger('shop_cart_add', resp);
			return resp;
		});
	}

	openModal(itemId) {
		ModalUtil.openAjax(
			window.elkitorg_config.cart_url + '?item_id=' + itemId,
			undefined,
			undefined,
			function () {
			}
		);
	}
}

export default new CartService();
